export const bigIntToString = (value: string | number): string => {
  if (typeof value === 'string') {
    const isNum = /^\d+$/.test(value);
    if (isNum) return BigInt(value).toString();
  }

  return value.toString();
};
